import React, { useContext, useEffect, useMemo } from "react";
import AuthClient from "../../api/AuthClient";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes/routes";
import RefreshButton from "../RefreshToUpdateData/RefreshToUpdateButton";
import { PartiesContext } from "../../GlobalContext/partiesContext";
import { LoadingAnimationContext } from "../../GlobalContext/loadingAnimation";
import { CitiesInfoContext } from "../../AllCitiesContext";
import AlsoGoingOutContent from "./AlsoGoingOutContent";
import { getCurrentCity, setStoredCurrentCity } from "../../utils/currentCity";
import { useAlsoGoingOutGroups } from "../../hooks/useServerDataQueries";


const AlsoGoingOut: React.FC = () => {

  const { alsoGoingOutGroups, setAlsoGoingOutGroupsContextData } = useContext(PartiesContext);
  const { alsoGoingOutHasLoadedOnce, setAlsoGoingOutHasLoadedOnce } = useContext(LoadingAnimationContext);

  const authClient = useMemo(() => new AuthClient(), []);
  const isLoggedIn = authClient.isLoggedIn();

  const navigate = useNavigate();

  const { citiesInfo, setSelectedCity } = useContext(CitiesInfoContext);

  const allCities = useMemo(
    () => [...(citiesInfo[0]?.allCities ?? [])].sort((a, b) => a.Name.localeCompare(b.Name)),
    [citiesInfo]
  );
  const currentCityId = getCurrentCity(authClient.getAuthenticationResponse())?.cityId ?? "";
  const {
    data: queriedAlsoGoingOutGroups = [],
    isError,
    isFetching,
    isLoading,
    isSuccess,
    refetch,
  } = useAlsoGoingOutGroups(currentCityId);

  const handleCityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const city = allCities.find((c) => c.Id === event.target.value);
    if (!city) return;
    setStoredCurrentCity({ cityId: city.Id, cityName: city.Name });
    setSelectedCity(city.Name);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(routes.Login);
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (isSuccess) {
      setAlsoGoingOutGroupsContextData(queriedAlsoGoingOutGroups);
      setAlsoGoingOutHasLoadedOnce(true);
    }
  }, [isSuccess, queriedAlsoGoingOutGroups, setAlsoGoingOutGroupsContextData, setAlsoGoingOutHasLoadedOnce]);

  useEffect(() => {
    if (isError) {
      setAlsoGoingOutHasLoadedOnce(true);
    }
  }, [isError, setAlsoGoingOutHasLoadedOnce]);

  if (alsoGoingOutGroups === null) {
    return null;
  }
  const handleButtonClick = () => {
    void refetch();
  };

  const requeststate = isFetching || isLoading ? "loading" : isError ? "error" : "idle";
  const isLoadingGroups = !alsoGoingOutHasLoadedOnce && (isLoading || isFetching);


  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
        <select
          aria-label="City"
          value={currentCityId}
          onChange={handleCityChange}
          disabled={allCities.length === 0}
          style={{
            backgroundColor: "transparent",
            color: "white",
            border: "3px solid #AF975A",
            borderRadius: 20,
            padding: "6px 32px 6px 14px",
            maxWidth: 220,
            cursor: allCities.length === 0 ? "not-allowed" : "pointer",
            appearance: "none",
            WebkitAppearance: "none",
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='%23af975a' d='M6 8 0 0h12z'/></svg>\")",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 12px center",
          }}
        >
          {allCities.length === 0 && <option value="">Loading cities...</option>}
          {allCities.map((city) => (
            <option key={city.Id} value={city.Id} style={{ color: "black" }}>
              {city.Name}
            </option>
          ))}
        </select>
        <RefreshButton requestState={requeststate} onClickHandler={handleButtonClick} />
      </div>
      <AlsoGoingOutContent
        isLoadingGroups={isLoadingGroups}
        alsoGoingOutGroups={alsoGoingOutGroups}
        authClient={authClient}
      />

    </>
  );
};

export default AlsoGoingOut;
